.wcDocker {
  background-color: $color-bg;
}

.wcModalBlocker {
  background-color: $color-bg;
}

.wcPanelBackground {
  background-color: $color-bg;
}

.wcPanelBackground .wcCenter {
  background-color: $color-bg;
}

.wcFrameFlasher {
  background-color: $color-bg;
}

.wcFrameShadower {
  background-color: $color-bg;
}

.wcFrameTitleBar {
  height: $title-height;
  background-color: $header-bg;
  border-bottom: $panel-border;
}

.wcFrameButton {
  width: 24px;
  height: 22px;
  display: flex;
  border-radius: $btn-border-radius;
  margin: auto;

  & .pg-font-icon {
    line-height: unset;
  }
}

/* darken % taken from bootstrap - button_variant */
.wcFrameButton:hover, .wcFrameButtonHover,  .wcFrameButton:focus {
  background-color: $btn-frame-close-bg;
}

.wcFrameButton.disabled {
  pointer-events: none;
  opacity: $btn-disabled-opacity;
}

.wcFrameButton .fa {
  align-self: center;
}

.wcFrameButtonBar {
  height: $title-height;
  background-color: inherit;
  border-bottom: $panel-border;
  padding: 0rem 0.25rem;

  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: row-reverse;
}

.wcLayout {
  display: block;
}

.wcLayoutGrid, .wcLayoutGrid tr, .wcLayoutGrid td {
  border: 1px solid $panel-border-color;
}

.wcFrameCenter {
  top: $title-height;
}

.wcPanelTab, .wcFrameTitle{
  color: $panel-color-fg;
  padding: $tabs-padding;
  margin: 0px;
}

.wcFloating {
  box-shadow: $dialog-box-shadow;
  z-index: 1050 !important;

  &.wcFrame, & .wcPanelBackground {
    max-width: 100%;
    max-height: 100%;
  }

  & .pg-panel-content {
    border-bottom: $card-border-radius;
  }

  & .wcFrameCornerNE,
  & .wcFrameCornerNW,
  & .wcFrameCornerSE,
  & .wcFrameCornerSW {
    height: $splitter-hover-width;
    width: $splitter-hover-width;
    background: transparent;
  }

  & .wcFrameCornerNE {
    border: $panel-border;
    border-left: none !important;
    border-bottom: none !important;
    border-radius: none;
    border-top-right-radius: $card-border-radius;
  }

  & .wcFrameCornerNW {
    border: $panel-border;
    border-right: none !important;
    border-bottom: none !important;
    border-radius: none;
    border-top-left-radius: $card-border-radius;
  }

  & .wcFrameCornerSE {
    border: $panel-border;
    border-top: none !important;
    border-left: none !important;
    border-radius: none;
    border-bottom-right-radius: $card-border-radius;
  }

  & .wcFrameCornerSW {
    border: $panel-border;
    border-right: none !important;
    border-top: none !important;
    border-radius: none;
    border-bottom-left-radius: $card-border-radius;
  }

  .wcFrameEdgeN, .wcFrameEdgeS {
    left: $card-border-radius !important;
    right: $card-border-radius !important;
  }

  .wcFrameEdgeW, .wcFrameEdgeE {
    top: $card-border-radius !important;
    bottom: $card-border-radius !important;
  }
}

.wcFloating .wcPanelTabActive {
  border-bottom: none;
  color: $color-fg;
  font-weight: bold;
}

.wcFloating .wcPanelTabActive:hover {
  background-color: $color-primary-light;
}

.wcFloating .wcFrameTitleBar {
  height: $title-height;
  background-color: $header-bg;
  border-bottom: $panel-border;
}

.wcFloating .wcFrameTitleBar.wcNotMoveable {
  cursor: move; //overriding the existing cursor behavior for not moveable panels
}

.wcTabIcon {
  background-position: center;
  padding: 0rem 0.75rem;

  &.fa, &.pg-font-icon{
    padding: 0rem 0.25rem 0rem 0rem;
  }
}

.wcFloating .wcPanelTab .wcTabIcon {
  color: $color-primary;
  padding: 0px 10px;
}

.wcPanelTabActive {
  border-bottom: $active-border;
  color: $active-color;
}

.wcFrameEdge {
  background-color: transparent;
  border: none;
  z-index: 5000;
}

.wcFrameEdgeN, .wcFrameEdgeS {
  height: math.div($splitter-hover-width, 2) + 1;
}

.wcFrameEdgeN {
  border-top: $panel-border;
}

.wcFrameEdgeS {
  border-bottom: $panel-border;
}

.wcFrameEdgeW, .wcFrameEdgeE {
  width: math.div($splitter-hover-width, 2) + 1;
}

.wcFrameEdgeW {
  border-left: $panel-border;
}

.wcFrameEdgeE {
  border-right: $panel-border;
}

.wcFrameCornerNW,
.wcFrameCornerNE,
.wcFrameCornerSW,
.wcFrameCornerSE {
  height: $splitter-hover-width;
  width: $splitter-hover-width;
}


.wcSplitterBarLine {
  background-color: $panel-border-color;
  border: none;
}

.wcSplitterBarV {
  width: $splitter-hover-width;

  & .wcSplitterBarLine {
    width: $panel-border-width;
  }
}

.wcSplitterBarH {
  height: $splitter-hover-width;

  & .wcSplitterBarLine {
    height: $panel-border-width;
  }
}

.wcSplitterBarV.wcSplitterBarStatic {
  width: 0px;
}
.wcSplitterBarH.wcSplitterBarStatic {
  height: 0px;
}


.wcGhost {
  background-color: $color-primary-light;
  border-radius: 6px;
}

.wcMenuList, .context-menu-list {
  border: 1px solid $dropdown-border-color;
  z-index: 1999 !important;
  background-color: $dropdown-bg;
  box-shadow: $dropdown-box-shadow;
  border-radius: $dropdown-border-radius;
}

.wcMenuItem, .context-menu-item {
  color: $dropdown-link-color;
  background-color: $dropdown-bg;
}

.wcMenuItemHover, .wcMenuItem:hover, .context-menu-item:not(.context-menu-not-selectable).hover, .context-menu-item:not(.context-menu-not-selectable):hover, .context-menu-hover {
  color: $dropdown-link-hover-color;
  background-color: $dropdown-link-hover-bg !important;
}

.wcMenuItem.disabled, .context-menu-item.disabled {
  color: $text-muted;
  background-color: $dropdown-bg;
}

.wcMenuSeparator, .context-menu-separator {
  border: 1px solid $dropdown-border-color;
  transform: scaleY(0.5);
}

.wcLoadingBackground {
  background: $loading-bg;
}

.wcLoadingLabel {
  top: 50%;
  left: 0;
  color: $loading-fg;
  width: 100%;
  font-size: 20px;
  position: absolute;
  text-align: center;
}

.wcLoadingIcon.pg-sp-icon {
  left: 0;
  top: calc(50% - 75px);
}

.wcPanelTab > div {
  // display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 125px;
}

.wcPanelTab-dynamic {
  max-width: 100% !important;
}

.wcPanelTabActive > div {
  width: auto !important;
  max-width: 100%;
}


.context-menu-item.context-menu-disabled {
  color: $text-muted;
  background-color: $dropdown-bg;
}

.context-menu-submenu::after {
  font-family: $font-family-icon;
  content: "\f054" !important;
  font-weight: 900;
  right: 15px;
  top: 3px;
  font-size: 0.6rem;
  line-height: 2;
  border-style: none;
}

.wcMenuSubMenu::before{
  content: none;
}

.tooltip {
  font-size: 0.7rem;
  line-height: 1.4em;
}

.tooltip.show {
  opacity: 1;
}

.wcTooltip-shortcut {
  justify-content: center;
  margin-top: 0.125rem;
  display: flex
}

.wcTooltip-shortcut-key{
  padding: 0 0.25rem;
  border: 1px solid $border-color;
  margin-right: 0.125rem;
  border-radius: $border-radius
}
